import ClashModel from '../ClashModel.js';

let instance = null;

export default class ClashModelManager {
    constructor() {

        // Singleton
        if (instance) {
            return instance;
        }
        instance = this;
        this.clashModels = [];

    }


    addModel(clashModel) {
        this.clashModels.push(clashModel);

    }

    getModels() {

        return this.clashModels;
    }

    getNumberofClashes()
    {
        return this.clashModels.length;
    }

    getModelByUuid(uuid){
        console.log("uuid in clashmanager",uuid)

        const mod = this.clashModels.find(model => model.meshuuid === uuid);
        console.log("mod:", mod)
        return mod;
    }

    getModelsByElementUuid(uuid) {
        return this.clashModels.filter(model =>
            model.constructionelement.id === uuid || model.installationelement.id === uuid
        );
    }

    reorganizeClash(clash) {
        const grouped = {};

        clash.parameters.forEach(param => {
            if (!param.visualization) return;

            if (!grouped[param.propertyset]) {
            grouped[param.propertyset] = [];
            }

            grouped[param.propertyset].push({
            name: param.name,
            value: param.value
            });
        });

        // Convert grouped object to array of {propertyset: [...]}
        const groupedArray = Object.entries(grouped).map(([propertyset, items]) => ({
            [propertyset]: items
        }));

        return {
            name: clash.installationelement.category,
            id: clash.meshuuid,
            parameters: grouped
        };
        }




    getModelOverviewByUuid(uuid) {
        //let idInt = parseInt(id);
        const mod = this.clashModels.find(clashModel => clashModel.meshuuid === uuid);
        //console.log(mod)

        //console.log(mod.constructionelement.category)
        
        let name = `${mod.constructionelement.category} vs. ${mod.installationelement.category}` 
        //console.log(name)
    
        // Prepare the main overview object
        const overview = {
            ElementName: name,
            ElementID: mod.uuid,
            //ElementCategory: mod.category,
            // ElementLinkedFile: mod.filePathName,
            Parameters: {}, // Group parameters by propertyset
        };
    
        // Add parameters dynamically, grouped by propertyset
        if (mod.parameters && Array.isArray(mod.parameters)) {
            mod.parameters.forEach(param => {
                if(param.visualization)
                {
                    const paramName = param.name; // Parameter name
                    const propertySet = param.propertyset || "General"; // Grouping header
                    const paramValue = param.value;
    
                    // Group parameters under their propertyset
                    if (!overview.Parameters[propertySet]) {
                        overview.Parameters[propertySet] = [];
                    }
                    overview.Parameters[propertySet].push({ name: paramName, value: paramValue });

                }

            });
        }

        //console.log(overview)
    
        return overview;
    }

    getClashListGroupedByConstruction() {
    const groupedMap = new Map();

    this.clashModels.forEach(clash => {
        const construction = clash.constructionelement;
        const installation = clash.installationelement;

        if (!groupedMap.has(construction.id)) {
            groupedMap.set(construction.id, {
                construction: construction,
                installations: []  // Now: array of { installation, clash }
            });
        }

        groupedMap.get(construction.id).installations.push({
            installation: installation,
            clash: clash
        });
    });

    // Convert Map to array and sort alphabetically by construction name
    return Array.from(groupedMap.values()).sort((a, b) =>
        (a.construction.name || "").localeCompare(b.construction.name || "")
    );
}



    setClashListForExport()
    {

        //console.log("we're here")
        let list = []
        //console.log(this.clashModels)
        for(let clash of this.clashModels)
        {


            let element = {};
            //console.log(element)
            element.Bulkhead = clash.parameters.find(param =>  param.name === "Bulkhead").value ?? "";
            element.BulkheadBoolean = clash.parameters.find(param =>  param.name === "BulkheadBoolean").value || false;
            element.ClashCreatedAt = clash.parameters.find(param =>  param.name === "ClashCreatedAt").value ?? "";
            element.ClashElementID = clash.parameters.find(param =>  param.name === "ClashElementID").value ?? "";
            element.ClashFamily =  `${clash.constructionelement.category} vs. ${clash.installationelement.category}` ?? "";
            element.ClashList = clash.parameters.find(param =>  param.name === "ClashList").value ?? "";
            element.ClashPoint = clash.parameters.find(param =>  param.name === "ClashPoint").value ?? "";
            element.ClashStatus = clash.parameters.find(param =>  param.name === "ClashStatus").value ?? "";
            element.ClashLevel = clash.parameters.find(param =>  param.name === "ClashLevel").value ?? "";
            element.ClashNumber = clash.parameters.find(param =>  param.name === "ClashNumber").value ?? "";
            element.ConstructionApertureDiameter = clash.parameters.find(param =>  param.name === "ConstructionApertureDiameter").value ?? ""
            element.ConstructionApertureHeight = clash.parameters.find(param =>  param.name === "ConstructionApertureHeight").value ?? "";
            element.ConstructionApertureWidth = clash.parameters.find(param =>  param.name === "ConstructionApertureWidth").value ?? "";
            element.ConstructionCategory = clash.parameters.find(param =>  param.name === "ConstructionCategory").value ?? "";
            element.ConstructionElementID = clash.parameters.find(param =>  param.name === "ConstructionElementID").value ?? "";
            element.ConstructionLinkedFile = clash.parameters.find(param =>  param.name === "ConstructionLinkedFile").value ?? "";
            element.ConstructionMaterial = clash.parameters.find(param =>  param.name === "ConstructionMaterial").value ?? "";
            element.ConstructionName = clash.parameters.find(param =>  param.name === "ConstructionName").value ?? "";
            element.ConstructionThickness = clash.parameters.find(param =>  param.name === "ConstructionThickness").value ?? "";
            element.ConstructionType = clash.parameters.find(param =>  param.name === "ConstructionType").value ?? "";
            element.ExceptionAlert = clash.parameters.find(param =>  param.name === "ExceptionAlert").value ?? "";
            element.FireRating = clash.parameters.find(param =>  param.name === "FireRating").value ?? "";
            element.SmokeRating = clash.parameters.find(param =>  param.name === "SmokeRating").value ?? "";
            element.AcousticRating = clash.parameters.find(param =>  param.name === "AcousticRating").value ?? "";
            element.FireRatingOneSided = clash.parameters.find(param =>  param.name === "FireRatingOneSided").value ?? "";
            element.InstallationCapped = clash.parameters.find(param =>  param.name === "InstallationCapped").value ?? "";
            element.InstallationCategory = clash.parameters.find(param =>  param.name === "InstallationCategory").value ?? "";
            element.InstallationDisplaySize = clash.parameters.find(param =>  param.name === "InstallationDisplaySize").value ?? "";
            element.InstallationElementID = clash.parameters.find(param =>  param.name === "InstallationElementID").value ?? "";
            element.InstallationHeight = clash.parameters.find(param =>  param.name === "InstallationHeight").value ?? "";
            element.InstallationInsideDiameter = clash.parameters.find(param =>  param.name === "InstallationInsideDiameter").value ?? "";
            element.InstallationLinkedFile = clash.parameters.find(param =>  param.name === "InstallationLinkedFile").value ?? "";
            element.InstallationMaterial = clash.parameters.find(param =>  param.name === "InstallationMaterial").value ?? "";
            element.InstallationName = clash.parameters.find(param =>  param.name === "InstallationName").value ?? "";
            element.InstallationOutsideDiameter = clash.parameters.find(param =>  param.name === "InstallationOutsideDiameter").value ?? "";
            element.InstallationSystemType = clash.parameters.find(param =>  param.name === "InstallationSystemType").value ?? "";
            element.InstallationThickness = clash.parameters.find(param =>  param.name === "InstallationThickness").value ?? "";
            element.InstallationType = clash.parameters.find(param =>  param.name === "InstallationType").value ?? "";
            element.InstallationWidth = clash.parameters.find(param =>  param.name === "InstallationWidth").value ?? "";
            element.InsulationName = clash.parameters.find(param =>  param.name === "InsulationName").value ?? "";
            element.InsulationThickness = clash.parameters.find(param =>  param.name === "InsulationThickness").value ?? "";
            element.InsulationType = clash.parameters.find(param =>  param.name === "InsulationType").value ?? "";
            element.InstallationAnnularGap = clash.parameters.find(param =>  param.name === "InstallationAnnularGap").value ?? "";
            element.ManualPlacement = clash.parameters.find(param =>  param.name === "ManualPlacement").value ?? "";
            element.MissingInfo = clash.parameters.find(param =>  param.name === "MissingInfo").value ?? "";
            element.Report = clash.parameters.find(param =>  param.name === "Report").value ?? "";
            element.Rotation = clash.parameters.find(param =>  param.name === "Rotation").value ?? "";
            element.Scope = clash.parameters.find(param =>  param.name === "Scope").value ?? "";
            element.Version = clash.parameters.find(param =>  param.name === "Version").value ?? "";
            element.WorkingHeightBacksideDistance = clash.parameters.find(param =>  param.name === "WorkingHeightBacksideDistance").value ?? "";
            element.WorkingHeightBacksideFloor = clash.parameters.find(param =>  param.name === "WorkingHeightBacksideFloor").value ?? "";
            element.WorkingHeightFrontsideDistance = clash.parameters.find(param =>  param.name === "WorkingHeightFrontsideDistance").value ?? "";
            element.WorkingHeightFrontsideFloor = clash.parameters.find(param =>  param.name === "WorkingHeightFrontsideFloor").value ?? "";
            element.ConstructionApertureShape = clash.parameters.find(param =>  param.name === "ConstructionApertureShape").value ?? "";
            element.Solution = clash.parameters.find(param =>  param.name === "Solution").value ?? "";
            //console.log(element)

            list.push(element)




        }

        return list;
    }


}